module.exports = __webpack_public_path__ + "img/star4-10.806971a6.svg";